module.exports = __webpack_public_path__ + "static/media/amazon-appstore-default.85a8922ad81ea5ff3d8b40d9ec5a2a63718172cdf8e6ba22e728d75250f564fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/core/icons/amazon-appstore-default.svg
// module id = 1349
// module chunks = 204